import { Injectable, signal, inject } from '@angular/core';
import { PlatformService } from '../auth/services/platform.service';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  /** Below this width (px) the web app switches to mobile chrome. */
  static readonly DESKTOP_MIN_WIDTH = 1024;

  private platform = inject(PlatformService);

  readonly useMobileChrome = signal(false);

  /** Whether the desktop sidebar is collapsed to icons only. Shared between the
   *  header toggle (in the brand zone) and the sidebar itself. */
  readonly sidebarCollapsed = signal(false);

  constructor() {
    this.update();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => this.update());
    }
  }

  /** Recompute the chrome flag from platform + current viewport width. */
  update(): void {
    const narrow = typeof window !== 'undefined' && window.innerWidth < LayoutService.DESKTOP_MIN_WIDTH;
    this.useMobileChrome.set(this.platform.isMobile() || narrow);
  }

  /** Toggle the desktop sidebar between expanded and icon-only. */
  toggleSidebar(): void {
    this.sidebarCollapsed.update(v => !v);
  }
}
